import {Grid, makeStyles, Typography} from "@material-ui/core";
import ProgressBar from "react-customizable-progressbar";
import {FormattedMessage} from "react-intl";
import React from "react";

const useStyles = makeStyles((theme) => ({
    title: {
        paddingBottom: theme.spacing(1),
        fontSize: 12,
        fontWeight: 600
    },
    subtitle: {
        fontSize: 12,
        color: '#696969',
    },
    count: {
        fontSize: 12,
    },
    circularProgressbar: {
        maxWidth: 120
    },
}));

function getPercentage(taken, total) {
    if (isNaN(taken) || isNaN(total) || total === 0) {
        return 0;
    }
    return ((Number(taken) / Number(total)) * 100);
}

export default function CustomProgressBar({
    mode,
    userRole,
    taken,
    total,
    balance,
    year,
    days = 'balance.days',
    hours,
    strokeColor,
    balanceTotal = 'balance.total',
    title,
    md = '',
    toBeExpiredBalance,
}) {
    const classes = useStyles();
    const [gridItemMd, setGridItemMd] = React.useState(3);

    React.useEffect(() => {
        if (
            mode === window.global.homeMode &&
            userRole !== window.global.hrAdmin
        ) {
            setGridItemMd(2);
        }
    }, [mode]);

    return (
        <React.Fragment>
            <Grid item md={md ? md : gridItemMd} xs={6}>
                <ProgressBar
                    className={classes.circularProgressbar}
                    progress={getPercentage(taken, total)}
                    strokeLinecap='butt'
                    strokeColor={strokeColor}
                    radius={40}
                    trackStrokeWidth={12}
                    strokeWidth={12}
                    inverse={true}
                />
            </Grid>
            <Grid item md={md ? md : gridItemMd} xs={6}>
                {year && 
                    <Typography className={classes.title}>
                        {year}
                    </Typography>
                }
                {title && 
                    <Typography className={classes.title}>
                        <FormattedMessage id={title} />
                    </Typography>
                }
                <Typography className={classes.subtitle}>
                    <>
                        <FormattedMessage id={balanceTotal} />
                        {' '}
                        <FormattedMessage id={hours ? hours : days} />
                    </>
                </Typography>
                <Typography className={classes.count}>
                    {total ? total.toFixed(1) : 0}
                </Typography>
                <Typography className={classes.subtitle}>
                    <>
                        <FormattedMessage id='balance.taken' /> 
                        {' '}
                        <FormattedMessage id={hours ? hours : days} />
                    </>
                </Typography>
                <Typography className={classes.count}>
                    {taken ? taken.toFixed(1) : 0}
                </Typography>
                <Typography className={classes.subtitle}>
                    <>
                        <FormattedMessage id='balance.balance' /> 
                        {' '}
                        <FormattedMessage id={hours ? hours : days} />
                    </>
                </Typography>
                <Typography className={classes.count}>
                    {balance ? balance.toFixed(1) : 0}{' '}
                    {toBeExpiredBalance > 0 && 
                        <i style={{color: '#3f51b5'}}>
                            <FormattedMessage 
                                id={'comp_leave_balance.note_to_be_expired'} 
                                values={{ hours: toBeExpiredBalance.toFixed(1) }} 
                            />
                        </i>
                    }
                </Typography>
            </Grid>
        </React.Fragment>
    );
}
